import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getLeadData } from '@/selectors/data';
import { CAPS } from '@/constants';

import { withReCaptchaProtectedCapability } from './withReCaptchaProtectedCapability';
import { stripQueryParameters } from '@/selectors/utils';

export const withLeadUpdateOnNext = WrappedCoponent => {
  const NewComponent = props => {
    const { leadData, onNext, postLead } = props;

    const onNextInner = (...params) => {
      const { leadData: leadOverrideData, onNextCallback } =
        params && params.length ? params[0] : {};

      return postLead(
        {
          body: {
            ...leadData,
            ...leadOverrideData,
            formSubmissionUrl: stripQueryParameters(window.location.href),
          },
        },
        () => {
          if (onNextCallback) {
            onNextCallback();
          }
          onNext(...params);
        },
      );
    };

    return <WrappedCoponent {...props} onNext={onNextInner} />;
  };

  NewComponent.propTypes = {
    leadData: PropTypes.object.isRequired,
    postLead: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
  };

  return compose(
    withReCaptchaProtectedCapability({ postLead: CAPS.LEAD_POST }),
    connect(state => ({
      leadData: getLeadData(state),
    })),
  )(NewComponent);
};
